import { render, staticRenderFns } from "./textCounter.vue?vue&type=template&id=ff1f7a9c&scoped=true"
import script from "./textCounter.vue?vue&type=script&lang=js"
export * from "./textCounter.vue?vue&type=script&lang=js"
import style0 from "./textCounter.vue?vue&type=style&index=0&id=ff1f7a9c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1f7a9c",
  null
  
)

export default component.exports